import { connectionBuildCancellationPolicies, ServerConnectionCancellationPolicy } from '@luxuryescapes/lib-refunds'
import config from 'constants/config'
import { isEnabledForFeature } from 'lib/featureFlagUtils'

import { getPackageUniqueKey } from 'lib/offer/offerUtils'

export interface ServerAvailablePrice {
  id: string;
  type: string;
  package_id: string;
  package_unique_key: string;
  room_rate_id: string;
  package_price: number;
  package_total_price: number;
  package_duration_prices?: number[];
  package_duration_surcharge_total: number;
  package_duration_extra_guest_surcharge_total: number;
  package_total_tax: number;
  package_property_fee: number;
  duration: number;
  connection?: {
    cancellationPolicies: Array<ServerConnectionCancellationPolicy>;
  }
}

interface AvailablePriceParams {
  timezone: string;
  regionCode: string;
  currencyCode: string;
}

export default function availablePriceMap(serverOfferBestPrice: ServerAvailablePrice, options: AvailablePriceParams) {
  const useTaxExlusivePrice = isEnabledForFeature(config.TAX_EXCLUSIVE_REGIONS, options.regionCode)
  const taxesAndFees = serverOfferBestPrice.package_total_tax ?? 0
  const propertyFees = serverOfferBestPrice.package_property_fee ?? 0
  return {
    offerId: serverOfferBestPrice.id,
    duration: serverOfferBestPrice.duration,
    price: serverOfferBestPrice.package_price + serverOfferBestPrice.package_duration_surcharge_total - (useTaxExlusivePrice ? taxesAndFees : 0),
    roomPrices: serverOfferBestPrice.package_duration_prices,
    taxesAndFees,
    propertyFees,
    packageId: serverOfferBestPrice.package_id,
    // this will make it match our own unique keys
    packageUniqueKey: getPackageUniqueKey(serverOfferBestPrice.package_id, serverOfferBestPrice.duration, serverOfferBestPrice.room_rate_id),
    roomRateId: serverOfferBestPrice.room_rate_id,
    cancellationPolicies: serverOfferBestPrice.connection ? connectionBuildCancellationPolicies(serverOfferBestPrice.connection.cancellationPolicies, options) : undefined,
  } as App.OfferAvailableRate
}
